// Fan speed model — shared by the fan screen and the combined switch+fan panels.
//
// The hardware understands six discrete duty values; 10 IS OFF (not 0). The
// labels and the short dial captions are the Dart's (fanTouchScreen.dart
// getFanStatusLabel / _speedStepLabel).
//
// Wire format: the fan command is "1-<speed>" — the leading "1" is the channel,
// NOT a relay index. Status comes back the same way, so a fan status parse must
// take the token after the LAST '-'.

export const FAN_SPEEDS = [10, 20, 40, 60, 80, 100];

export const FAN_OFF = 10;

export function fanStatusLabel(speed) {
  if (speed <= 10) return 'OFF';
  if (speed <= 20) return 'Very Low';
  if (speed <= 40) return 'Low';
  if (speed <= 60) return 'Medium';
  if (speed <= 80) return 'High';
  return 'MAX';
}

// Short caption in the middle of the dial: Off, 1..4, Max.
export function fanStepLabel(speed) {
  const i = FAN_SPEEDS.indexOf(speed);
  if (i <= 0) return 'Off';
  if (i >= FAN_SPEEDS.length - 1) return 'Max';
  return String(i);
}

export function fanFraction(speed) {
  const i = FAN_SPEEDS.indexOf(speed);
  return i <= 0 ? 0 : i / (FAN_SPEEDS.length - 1);
}

// Pull a speed out of any shape the backend/MQTT use: "1-100", "[1128755]1-100",
// or a bare "100". Returns null when there is nothing numeric (empty seed,
// offline) so the caller can leave the state UNKNOWN rather than forcing OFF.
export function parseFanSpeed(raw) {
  let s = String(raw ?? '').trim();
  if (!s) return null;
  const rb = s.indexOf(']');
  if (s.startsWith('[') && rb !== -1) s = s.substring(rb + 1);
  const hash = s.indexOf('#');
  if (hash !== -1) s = s.substring(0, hash);
  s = s.trim();
  const dash = s.lastIndexOf('-');
  const token = dash !== -1 ? s.substring(dash + 1) : s;
  const n = parseInt(token.trim(), 10);
  return Number.isNaN(n) ? null : n;
}

export function fanCommand(speed) {
  return `1-${speed}`;
}
